export default __webpack_public_path__ + "static/media/SCIENCE_CHEMISTRY.bce1100d.svg";